import type { GA_OTP_LABEL } from 'Components/pages/VehiclePayment/VehiclePayment.const';

export enum OtpSetupModalVariant {
	FORM = 'Form',
	SUCCESS = 'Success',
}

export type OtpSetupModalProps = {
	onDismiss: () => void;
	onSuccess: () => void;
	origin?:
		| 'otp_setup_on_login'
		| 'otp_setup_seller_details'
		| 'otp_setup_withdrawals'
		| 'otp_setup_wallet'
		| 'otp_setup_billing'
		| 'otp_setup_payment'
		| 'otp_setup_chipping'
		| 'otp_setup_access_finance_letter'
		| typeof GA_OTP_LABEL.OTP_SETUP_SHOWN;
	show: boolean;
	variant?: OtpSetupModalVariant;
};
